import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const checkPostCode = (postCode) => axios.get(`https://postcodes.io/postcodes/${postCode}`);
